/**
 * External dependencies.
 */
import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import { isMobile } from "react-device-detect";

const ProgressBar: React.FC = () => {
  const ref: any = useRef();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [progressBarFixed, setProgressBarFixed] = useState(false);

  useEffect(() => {
    document.addEventListener("scroll", listenToScrollEvent);

    return () => document.removeEventListener("scroll", listenToScrollEvent);
  }, []);

  const listenToScrollEvent = () => {
    requestAnimationFrame(() => {
      calculateScrollDistance();
    });
  };

  const calculateScrollDistance = () => {
    if (!ref.current) {
      return;
    }
    const scrollTop = window.pageYOffset;
    const windowHeight = window.innerHeight;
    const docHeight = getDocHeight();

    const totalDocScrollLength = docHeight - windowHeight;
    const scrollPosition = scrollTop / totalDocScrollLength;

    setScrollPosition(scrollPosition);

    const offsetMobile = isMobile ? 56 : 0;
    const isFixed = ref.current.getBoundingClientRect().top - offsetMobile <= 0;

    setProgressBarFixed(isFixed);
  };

  const getDocHeight = () => {
    return Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );
  };

  return (
    <div
      ref={ref}
      className="progress-bar-container"
    >
      <div
        className={classNames("progress-bar", { fixed: progressBarFixed })}
        style={{
          '--scroll-factor': scrollPosition,
        } as React.CSSProperties}
      ></div>
    </div>
  );
};

export default ProgressBar;
